import { Button } from '@mui/material';
import dayjs from 'dayjs';
import { useEffect, useState, useMemo } from 'react';
import { NavLink } from 'react-router-dom';
import { CommodityManagementApi } from '../../../../Apis/Apis';
import {
    AuditTrailModel,
    PositionModel,
    GetCustomerSettingsResponse,
    AllocationModel, ReportType, YearDataModel, CustomerReportModel
} from '../../../../Generated/Commodity-Management-Api';
import { useLoadingState } from '../../../../Hooks';
import { RootState, useApplicationSelector } from '../../../../Redux/ReduxStore';
import { StoneXDivider, StoneXLoading, StoneXRow } from '../../../StoneX';
import StoneXMainPage from '../../../StoneX/StoneXMainPage/StoneXMainPage';
import { deepMerge } from '../../../../Helpers/ObjectHelper';
import { AllocationReportColumn, AllocationReportConfiguration, AllocationReportUserOverride } from './Types';
import { GroupingOption } from '../../../../Types/GridRow';
import AllocationTable from './AllocationTable';
import { UpdateAllocationsModal } from './UpdateAllocations/UpdateAllocationsModal';
import { ContractDateHelper, downloadFile } from '../../../../Helpers';

export default function ViewAllocationsPage() {

    const [editAllocationModel, setEditAllocationModel] = useState<AllocationModel | undefined>();
    const [validationModalOpen, setValidationModalOpen] = useState(false);
    const [allocations, setAllocations] = useState<AllocationModel[]>([]);
    const [editAllocationModalOpen, setEditAllocationModalOpen] = useState(false);
    const [selectedAllocationId, setSelectedAllocationId] = useState<number | undefined>(undefined);
    const [modalOpen, setModalOpen] = useState(false);
    const [isLoadingAllocations, setIsLoadingAllocations] = useState(true);
    const [positions, setPositions] = useState<PositionModel[]>([]);

    const customerSettings = useApplicationSelector((state: RootState): GetCustomerSettingsResponse => state.commodityManagement.customerSettings);
    const loadingState = useLoadingState();


    async function onAllocationSave(dealTicketId: number) {
        await CommodityManagementApi.listPositions(
            undefined,
            undefined, //mtmDate
            false, //include expiration dates
            false, //include market prices
            false, // don't use display units - use original units
            undefined, // no scenario market prices
            undefined, //commodityFilter,
            undefined, //locationFilter,
            undefined, //counterpartyFilter,
            undefined, //trade start date
            undefined, //trade end date
            undefined, // startDate.year,
            undefined, // startDate.month,
            undefined, //label (ignore)
            undefined, // endDate.year,   //get all forward positions
            undefined, // endDate.month,  //get all forward positions
            undefined, // label
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            dealTicketId, // filter by deal ticket id
        ).then((q) => {
            const newPositions = q.data.rows ?? [];
            
            setEditAllocationModalOpen(false);
        });
    }

    function onAllocationDelete(allocationId: number) {
        //setPositions(previous => previous.filter(p => p.dealTicketId !== dealTicketId));
        //setEditDealTicketModalOpen(false);
    }
    function getInitalAllocations() {
        setIsLoadingAllocations(true); // Start loading
        CommodityManagementApi.listAllocations(
            loadingState.setLoadingState,
            undefined, //commodityFilter,
            undefined, //locationFilter,
            undefined, //counterpartyFilter,
            undefined, //trade start date
        ).then((q) => {
            setAllocations(q.data.rows ?? []);
            setIsLoadingAllocations(false); // Done loading
        });

        const currentYear = dayjs().year();
        const startDate = ContractDateHelper.getStartContractDate(currentYear, customerSettings?.fiscalMonthOffset);

        CommodityManagementApi.listPositions(
            loadingState.setLoadingState,
            undefined, //mtmDate
            false, //include expiration dates
            false, //include market prices
            false, // don't use display units - use original units
            undefined, // no scenario market prices
            undefined, //commodityFilter,
            undefined, //locationFilter,
            undefined, //counterpartyFilter,
            undefined, //trade start date
            undefined, //trade end date
            startDate.year,
            startDate.month,
            undefined, //label (ignore)
            undefined, // endDate.year,   //get all forward positions
            undefined, // endDate.month,  //get all forward positions
            undefined, // label
            undefined, // include closed positions
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            false,
            true
        ).then((q) => {
            setPositions(q.data.rows ?? []);
        });
    }

    useEffect(getInitalAllocations, []);

    function editAllocation(allocationGroupId?: number) {
        // This will work as add deal ticket if dealTicketId is undefined
        setEditAllocationModel(allocations.find(f => f.allocationGroupId == allocationGroupId!)!);
        setEditAllocationModalOpen(true);
    }
    function viewAuditTrail(positionId: number) {

    }

    // Handler for row click
    const handleRowClick = (allocationId: number) => {
        setSelectedAllocationId(allocationId);
        setModalOpen(true);
    };

    return (
        <StoneXMainPage>
            {isLoadingAllocations ? (
                <StoneXLoading /> // Show loading spinner or indicator
            ) : (
                <>
                    <StoneXRow align="baseline">
                        <h1>Allocations</h1>
                        <span className="pull-right">
                            <Button onClick={() => editAllocation()}>Create New Group</Button>
                        </span>
                    </StoneXRow>

                    <StoneXDivider />

                    <AllocationTable
                        customerSettings={customerSettings}
                        allocations={allocations}
                        onEditAllocation={editAllocation}
                        onViewAuditTrail={viewAuditTrail}
                    />

                    <UpdateAllocationsModal
                        allocationModel={editAllocationModel}
                        positions={positions}
                        open={editAllocationModalOpen}
                        onClose={() => setEditAllocationModalOpen(false)}
                        onSave={() => setEditAllocationModalOpen(false)}
                        onDelete={() => setEditAllocationModalOpen(false)}
                    />
                </>
            )}
        </StoneXMainPage>
    );
}